import { model as router } from '!/router'
import { createEvent, createStore, sample } from 'effector'
import { model as signInModel } from '~/features/subscriber/sign-in'

export const init = createEvent()
export const left = createEvent()

const $currentPage = createStore(false)
  .on(init, () => true)
  .reset(left)

sample({
  clock: init,
  target: signInModel.signOutFx,
})

sample({
  clock: signInModel.signOutFx.finally,
  source: router.$location,
  filter: $currentPage,
  fn: (location) => {
    const matched = location?.pathname.match(/~(.*)$/)
    return { ...location, pathname: matched ? matched[1] || '/' : '/' }
  },
  target: router.navigateReplace,
})
